module.exports = __webpack_public_path__ + "d7ca567866398d85dcce4231d81a344f.svg";